/* Self-contained (its own literals, not `var(--bottom-margin-bottom)`/
   `var(--box-shadow-props)` from whichever reading mode's own CSS module
   happens to be loaded) -- this component is shared across responsive,
   single-page replica and double-page replica, and shouldn't depend on
   which of their stylesheets is present. */
.issue-cover {
	cursor: pointer;
	position: absolute;
	height: 80px;
	/* Matches every home screen's own cover ratio (e.g. `templates/basic/
	   home/magazine/magazine.module.css`'s `.latest-issue figure img`/
	   `.issue img`, the same 9:12 used by nearly every other template's
	   home) -- this is the same cover artwork, just shown small here, so a
	   fixed pixel width cropped it differently than the reader saw on the
	   home screen a moment earlier. */
	aspect-ratio: 9 / 12;
	background: var(--cf-app-color-surface);
	transition: background-color ease-out 220ms;
	border-width: 1px;
	border-style: solid;
	border-color: var(--cf-app-color-border);
	border-radius: 4px;
	z-index: 1;
	bottom: 0;
	inset-inline-start: 0;
	margin-bottom: 20px;
	margin-inline-start: 20px;
	box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.25);
	/* A real `<button>`, not a decorative `<div>` -- resets the UA's default
	   button chrome (padding, font inheritance, focus/appearance quirks) so
	   it still renders exactly like a plain image card. */
	padding: 0;
	font: inherit;
	appearance: none;
	-webkit-appearance: none;
	overflow: hidden;
}

/* Phones and tablets (`DESKTOP_BREAKPOINT`, 1024px, and below): scrolling an
   article down slides the cover straight off the bottom edge -- no fade --
   and scrolling back up slides it back in. The distance is its own height
   plus the bottom margin and a little for the shadow, so none of it peeks
   above the edge at either size. Desktop never gets `data-hidden`'s effect.
   It stays focusable, so a keyboard focus brings it back into view. */
@media only screen and (max-width: 1024px) {
	.issue-cover {
		transition:
			background-color ease-out 220ms,
			transform ease-out 350ms;
	}

	.issue-cover[data-hidden='true'] {
		transform: translateY(calc(100% + 20px + 12px));
	}

	.issue-cover[data-hidden='true']:focus-visible {
		transform: none;
	}
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
	.issue-cover[data-hidden='true'] {
		transform: translateY(calc(100% + 35px + 24px));
	}
}

/* `data-motion`, not the media query: it also carries the reader's
   Settings override (see useReducedMotion, @shared/lib/hooks). */
:root[data-motion='reduce'] .issue-cover {
	transition: background-color ease-out 220ms;
}

/* `IssueCoverPlaceholder` while the issue loads: same look on purpose (it
   morphs into and is swapped for the real cover), only the cursor says it
   can't be pressed yet. */
.issue-cover:disabled {
	cursor: default;
}

.issue-cover img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	/* Long-pressing a cover opens Safari's save/copy sheet, which no native
	   reader does. */
	-webkit-touch-callout: none;
}

/* Twice the size from tablet width up -- drawn at that size, not scaled
   up with `transform: scale(2)`: Safari rasterizes a transformed element at
   its untransformed size and stretches that bitmap, so the cover (and its
   morph snapshot) came out blurry there while Chromium re-rasterized it
   sharp. Every value is what the old `scale(2)` produced -- the same 120x160
   box at the same spot (the scale grew it from its centre, so the margins
   are the old 75px minus half the growth), with the border, radius and
   shadow doubled the way the transform doubled them. */
@media only screen and (min-width: 768px) {
	.issue-cover {
		height: 160px;
		border-width: 2px;
		border-radius: 8px;
		box-shadow: 2px 2px 12px 0px rgba(0, 0, 0, 0.25);
		background: oklch(var(--cf-app-color-surface) / 30%);
		border-color: oklch(from var(--cf-app-color-border) l c h / 30%);
	}
}
